export interface RefreshedMemberToken { access_token: string }

/** Identifies only the authentication errors emitted by the member API. */
export function isMemberAuthError(error: any) {
  const status = Number(error?.statusCode || error?.status || error?.response?.status || error?.data?.statusCode || 0)
  const code = Number(error?.data?.code || error?.response?._data?.code || 0)
  return status === 401 || code === 40101 || code === 40102 || code === 40103
}

/**
 * Executes an authenticated request once more after a successful token refresh.
 * The callback boundary keeps the retry policy framework-independent and makes
 * its security-sensitive behavior directly unit-testable.
 */
export async function retryMemberRequest<T>(
  request: (authorization: string) => Promise<T>,
  authorization: string,
  refresh: () => Promise<RefreshedMemberToken | null>,
  onAuthenticationFailure: () => Promise<void>,
): Promise<T> {
  try {
    return await request(authorization)
  } catch (error) {
    if (!isMemberAuthError(error)) throw error
    const pair = await refresh()
    if (!pair?.access_token) {
      await onAuthenticationFailure()
      throw error
    }
    try {
      return await request(`Bearer ${pair.access_token}`)
    } catch (retryError) {
      if (isMemberAuthError(retryError)) await onAuthenticationFailure()
      throw retryError
    }
  }
}
